module.exports = __webpack_public_path__ + "static/img/35_pro.b069e0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/35_pro.jpg
// module id = j1UY
// module chunks = 0